import Typography from "@material-ui/core/Typography";
import {Button, Grid, Paper, TableCell, TableRow} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import {routePaths} from "../../../../shared/utils/constants/routePaths";
import {useHistory} from "react-router-dom";
import SimpleTable from "../../../../shared/components/tables/simple-table/SimpleTable";
import {TABLE_SIZE_M, TABLE_SIZE_XL} from "../contratto-digitale/digital-contract-details/tabs/offerte/OfferteHelper";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import EmptyRow from "../../../ui/tables/rows/empty-row/EmptyRow";
import * as actions from "../../../../store";

const OrdiniConsip = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const ordiniConsip = useSelector(state => state.ordiniConsipReducer.ordiniConsipTableData)
    const customerId = useSelector(state => state.authReducer.selectedCompany.integrationId)

    const handleBackClick = () => {
        history.push(routePaths.MOBILE);
    }

    const handleVediClick = (row) => {
        history.push(`/mobile/ordini-consip-tm9/${row.idTrattativa}`);
    }

    useEffect(() => {
        dispatch(actions.getOrdiniConsipTableData(customerId))
    }, [dispatch, customerId])

    const headCells = [
        {
            id: "ordini-consip-nome",
            text: "nome",
            width: TABLE_SIZE_XL
        },
        {
            id: "ordini-consip-details-button",
            text: "",
            width: TABLE_SIZE_M,
        },
    ];

    const tableRows = (data) => {
        return (
           data.length ? data.map((row, idx) => (
                <TableRow key={`digital-contract-bulk-row-${idx}`}>
                    <TableCell>
                        <Typography variant="subtitle2">
                            {row.nome}
                        </Typography>
                    </TableCell>
                    <TableCell align='right'>
                        <Button variant='text' onClick={() => handleVediClick(row)}
                                color='primary'>
                            vedi dettagli
                        </Button>
                    </TableCell>
                </TableRow>
            ))
         : <EmptyRow text="dato" colSpan={headCells.length + 2} />
        )
    };

    return (
        <Grid container
              spacing={4}
              direction="column">
            <Grid item>
                <Button color="primary"
                        onClick={handleBackClick}
                        variant="text"
                        startIcon={<ArrowBackIosIcon fontSize="small"/>}>
                    Indietro
                </Button>
            </Grid>

            <Grid item>
                <Typography variant="h6">Ordini CONSIP TM9</Typography>
            </Grid>

            <Grid item style={{width: "100%"}}>
                <Paper style={{padding: '0 1em'}}>
                    <SimpleTable
                        headCells={headCells}
                        tableRows={tableRows(ordiniConsip.data)}
                        loading={ordiniConsip.loading}
                    />
                </Paper>
            </Grid>
        </Grid>

    )
}

export default OrdiniConsip;
